import { useSearchPageQueryParams } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
export var useSearchPageZeroIndexedPageNumber = function() {
    return useSearchPageQueryParams().zeroIndexedPageNumber;
};
